import {App} from "./src/App/App";
App.initialize();
